(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('passwordValidation', [PasswordValidationFn]);

    /* password validation directive */
    /* if rules change, also update server-side validation */
    function PasswordValidationFn() {

        var directive = {
            link: link,
            require: 'ngModel',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs, mCtrl) {
            function validate(value) {
                if (value === null || value.length < 8) {
                    mCtrl.$setValidity('passwordValid', false);
                } else {
                    mCtrl.$setValidity('passwordValid', true);
                }
                return value;
            }

            mCtrl.$parsers.push(validate);
        }
    }
})();